module.exports = __webpack_public_path__ + "img/Slider-AUTO_es.8ac2d138.png";